var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDelete(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 18H49V51C49 54.866 45.866 58 42 58H22C18.134 58 15 54.866 15 51V18Z",
    fill: "#FBB8A9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40 15L40 12C40 9.79086 38.2091 8 36 8L28 8C25.7909 8 24 9.79086 24 12L24 15",
    stroke: "#F64E29",
    strokeWidth: 4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11 15C11 14.4477 11.4477 14 12 14H52C52.5523 14 53 14.4477 53 15V18C53 18.5523 52.5523 19 52 19H12C11.4477 19 11 18.5523 11 18V15Z",
    fill: "#F64E29"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26 25C26.5523 25 27 25.4477 27 26L27 48C27 48.5523 26.5523 49 26 49L25 49C24.4477 49 24 48.5523 24 48L24 26C24 25.4477 24.4477 25 25 25L26 25Z",
    fill: "#F64E29"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M38 25C38.5523 25 39 25.4477 39 26L39 48C39 48.5523 38.5523 49 38 49L37 49C36.4477 49 36 48.5523 36 48L36 26C36 25.4477 36.4477 25 37 25L38 25Z",
    fill: "#F64E29"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/Delete.00d0d59993e688e7f3a048a6caee89d0.svg";
export { ForwardRef as ReactComponent };